import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'offer-short-description',
  styleUrl: 'offer-short-description.css',
})
export class OfferShortDescription {
  @Prop() offerId: string = '';
  @Prop() email: string = '';
  @Prop() zipCode: string | number = '';
  @Prop() shouldDisplay: boolean = false;

  render() {
    if (!this.shouldDisplay) {
      return null;
    }
    const { offerId, email, zipCode } = this;
    return (
      <Host>
        <div class="text-xs space-y-1 mt-2">
          <div>Offer ID: {offerId}</div>
          {email && <div>Email: {email}</div>}
          <div>ZIP Code: {zipCode}</div>
        </div>
      </Host>
    );
  }
}
